import { z } from 'zod/v4';

export const vehiclesImportResultsSchema = z.array(
  z
    .object({
      validationResult: z.string(),
      importResult: z.string(),
      item: z.object({
        vehicleId: z.string(),
        name: z.string(),
        groups: z
          .array(
            z.object({
              vehicleGroupName: z.string(),
            })
          )
          .optional()
          .nullable(),
      }),
    })
    .transform((value) => {
      return {
        ...value,
        item: {
          ...value.item,
          Groups: (value.item.groups ?? [])
            .map((group) => group.vehicleGroupName)
            .join('|'),
        },
      };
    })
);
